import type {
  CoreColorConfig,
  CoreLibrary,
  IconSet,
  ImageSet,
} from "@b2bportal/core-themes";
import type { FeatureFlagsContext } from "@b2bportal/core-utilities";
import type { Branding, ClientName, Translation } from "@hopper-b2b/types";
import type { ThemeOptions } from "@material-ui/core/styles";
import type { LabComponentsPropsList } from "@material-ui/lab/themeAugmentation";

export type MUIThemeDefinition = ThemeOptions & Partial<LabComponentsPropsList>;

export enum Env {
  production = "production",
  staging = "staging",
  development = "development",
  local = "local",
}

export type Route = {
  path: string;
  component: React.ReactNode;
  identifier: string;
};

export type BootConfig = {
  env: Env;
  datadog?: {
    serviceName: string;
    clientToken: string;
    // TODO: This property might be interfered
    reactVersion: string;
  };
};

export type PortalConfig = {
  clientName: ClientName;
  bootConfig: BootConfig;
  theme: ConfigTheme;
  featureFlags: FeatureFlagsContext;
  branding: Branding;
  translations?: Translation;
  providedTranslations?: Translation;
  useGeneratedTranslations?: boolean;
  routerBasename?: string;
};

export type BasicConfig = {
  clientName: ClientName;
  bootConfig: Partial<BootConfig>;
  theme: ConfigTheme;
  featureFlags?: FeatureFlagsContext;
  branding: Branding;
  translations?: Translation;
  providedTranslations?: Translation;
  routerBasename?: string;
};

export type ConfigTheme = {
  muiTheme?: MUIThemeDefinition;
  variables: CoreColorConfig;
  styleOverrides?: CoreLibrary;
  icons: Partial<IconSet>;
  images: Partial<ImageSet>;
};
